var component = require('../../../lib/js/component.js');

function PlanInteractiveTool() {
    var _this = this;
    window.webappIFP = null;
 
    this.initialize = function(element) {
         _this.$element = $(element);

         window.setUpTabs = true;
         window.isFirstLoad = true;
        _this.$interactiveTool = _this.$element.find('.PlanInteractiveTool__InteractiveTool');
        _this.$loadingContainer = _this.$element.find('.PlanInteractiveTool__loading');
        _this.$staticFloorPlan = _this.$element.find('.PlanInteractiveTool__StaticFloorPlan');
        _this.$tabContainers = _this.$element.find('.PlanInteractiveTool__tab-container');
        _this.$tabs = _this.$element.find('.PlanInteractiveTool__tab');
        _this.$mobileHeaders = _this.$element.find('.PlanInteractiveTool__mobile-header');
        _this.$mobileTabsContainer = _this.$element.find('.PlanInteractiveTool__mobile-tabs');
        _this.$mobileTabs = _this.$element.find('.PlanInteractiveTool__mobile-tab');
        _this.$iframe = _this.$element.find('.PlanInteractiveTool__iframe');
        _this.$printBtn = _this.$element.find(".PlanInteractiveTool__utilities--print");
        _this.$saveBtn = _this.$element.find(".PlanInteractiveTool__utilities--save");

         // Force reload iframe
         var iframe = _this.$iframe[0];
         if (iframe) {
             var src = iframe.src;
             iframe.src = "";
             iframe.src = src;
         }
 
        _this.$tabs.on('click', _this.tabClick.bind(_this));
        _this.$mobileTabs.on('click', _this.tabClick.bind(_this));
 
        _this.$iframe.on('load', _this.iframeLoaded.bind(_this));
        _this.$iframe.on('apiLoaded', _this.setUpTabs.bind(_this));
 
        // Print & Save buttons
        _this.$printBtn.on("click", function() {
            if(window.webappIFP) window.webappIFP.printBrochure();
        });
 
        _this.$saveBtn.on("click", function() {
            var $img = $(this).find('img');
            var isSaved = $img.attr('data-is-saved').toLowerCase() === "true";
            var userId = window.Pulte.user ? window.Pulte.user.UserId : "";
            var sessionId = window.Pulte.SessionId || "";
 
            if(!isSaved) {
                window.webappIFP.saveConfig(sessionId, userId, "callBackSaveFP");
            } else {
                window.webappIFP.deleteConfig(userId);
            }
        });
        _this.handleUtilityBtnNavigation();
    }

    this.iframeLoaded = function() {
        if(window.webappIFP) return; // Only init once
 
        window.webappIFP = new ZONDA.WebappIFPApi(document.getElementById('PlanInteractiveToolIframe'), function(result){
            if (result.success) {
                window.webappIFP.getModules(function () {
                    setTimeout(function() {
                      _this.$iframe.trigger('apiLoaded');
                       if(window.isFirstLoad) {                         
                          _this.$loadingContainer.addClass('d-none');                  
                          window.isFirstLoad = false;
                      }
                      var userId = window.Pulte.user ? window.Pulte.user.UserId : "";
                      if(userId && window.webappIFP.loadConfig) {
                          window.webappIFP.loadConfig(userId, "callBackLoadFP");
                      }
                    }, 200);
                });
            }
        });
     }

    this.setUpTabs = function () {
      window.setUpTabs = false;
      var $validTabs = [];
      var $validMobileTabs = [];
      var modules = window.webappIFP ? window.webappIFP.modules : {};
      // validate tabs
      for (var i = 0; i < _this.$tabContainers.length; i++) {
          var $tab = $(_this.$tabContainers[i]);
          var tabId = $tab.find('.PlanInteractiveTool__tab').data('module-id');
  
          if (modules && modules[tabId]) {
              $validTabs.push($tab);
              $validMobileTabs.push($(_this.$mobileTabs[i]));
          } else {
              $tab.remove();
          }
      }
  
      // fallback: if modules is empty but we should still keep the first tab (Customize Plan)
      if ((!modules || !Object.keys(modules).length) && _this.$tabContainers.length) {
          $validTabs.push($(_this.$tabContainers[0]));
          $validMobileTabs.push($(_this.$mobileTabs[0]));
      }
  
      if ($validTabs.length) {
          // hide static floorplan since we have interactive tool tabs
          _this.$staticFloorPlan.addClass('d-none');
  
          // remove FloorPlan nav links
          $('.CommunityPersistentNav__tabs a[data-nav-target="#FloorPlanModule"]').closest('li').remove();
          $('.CommunityPersistentNav__dropdown-menu a[data-nav-target="#FloorPlanModule"]').closest('li').remove();
  
          _this.setUpValidTabs($validTabs, $validMobileTabs);
          _this.updateTabsAndRebind();
      } else {
          // no valid tabs → hide interactive tool and remove its nav links
          _this.$interactiveTool.addClass('d-none');
          $('.CommunityPersistentNav__tabs a[data-nav-target="#PlanInteractiveTool"]').closest('li').remove();
          $('.CommunityPersistentNav__dropdown-menu a[data-nav-target="#PlanInteractiveTool"]').closest('li').remove();
      }
    };
    
 
    this.tabClick = function(e){
        var index = $(e.currentTarget).data('tab-index');
        var moduleId = $(e.currentTarget).data('module-id');
 
        for(var i=0;i<_this.$tabs.length;i++){
            var $tab = $(_this.$tabs[i]);
            var $mobileTab = $(_this.$mobileTabs[i]);
            var $header = $(_this.$mobileHeaders[i]);
 
            if(i===index){
                $tab.addClass('selected');
                $mobileTab.addClass('selected');
                $header.removeClass('d-none');
            } else {
                $tab.removeClass('selected');
                $mobileTab.removeClass('selected');
                $header.addClass('d-none');
            }
        }
 
       if (window.webappIFP) {       
           if (typeof window.webappIFP.showModule === "function") {
               window.webappIFP.showModule(moduleId);
           }
        }
    }

    this.updateTabsAndRebind = function () {    
        var _this = this;
        var $tabs = this.$element.find('.PlanInteractiveTool__tab[role="tab"]');
        var $tabList = this.$element.find('.PlanInteractiveTool__tabs[role="tablist"]');
    
        var tabFocus = 0;
    
        $tabList.on("keydown", function(e) {
            if (e.keyCode === 13) { // Check for Enter key (keyCode 13)
                e.preventDefault(); 
                _this.tabClick({ currentTarget: $tabs[tabFocus] });
            }
    
            if (e.keyCode === 39 || e.keyCode === 37) { 
                // Right (39) or Left (37) arrow keys
                if (e.keyCode === 39) {
                    tabFocus++;
                    if (tabFocus >= $tabs.length) {
                        tabFocus = 0; 
                    }
                } else if (e.keyCode === 37) {
                    tabFocus--;
                    if (tabFocus < 0) {
                        tabFocus = $tabs.length - 1; 
                    }
                }
    
                $tabs.eq(tabFocus).attr("tabindex", "0").focus(); // Set focus on the new tab
            }
        });
    
        // Update tabFocus when a tab gains focus (for Tab key navigation)
        $tabs.on("focus", function() {
            tabFocus = $tabs.index(this);
        });
    
        $tabs.on('click', this.tabClick.bind(this));
    };
    
    this.handleUtilityBtnNavigation = function() {

        // Get all focusable utility buttons within the utility container (Save, Share, Print)
        var $utilityButtons = this.$element.find('.PlanInteractiveTool__utilities a');
        var utilityBtnFocus = 0;
    
        $utilityButtons.attr('tabindex', 0);
    
        this.$element.find('.PlanInteractiveTool__utilities').on('keydown', function(e) {
            if (e.keyCode === 13) { // Enter key
                e.preventDefault();
                // Manually trigger 'click' on the focused <a> element when the Enter key is pressed
                $utilityButtons.eq(utilityBtnFocus).trigger('click');
            }

            if (e.keyCode === 39) { // Right Arrow key
                utilityBtnFocus++;
                if (utilityBtnFocus >= $utilityButtons.length) {
                    utilityBtnFocus = 0;
                }
                $utilityButtons.eq(utilityBtnFocus).focus();
            }
    
            if (e.keyCode === 37) { // Left Arrow key
                utilityBtnFocus--;
                if (utilityBtnFocus < 0) {
                    utilityBtnFocus = $utilityButtons.length - 1;
                }
                $utilityButtons.eq(utilityBtnFocus).focus();
            }
        });

        $utilityButtons.on('focus', function() {
            // Update utilityBtnFocus to the currently focused button
            utilityBtnFocus = $utilityButtons.index(this); 
        });
    };
     
    this.setUpValidTabs = function($validTabs, $validMobileTabs) {
        var tabColumns = 12 / $validTabs.length;
        var tabColumnClass = 'col-sm-' + tabColumns;

        var mobileTabColumns = 12 / $validMobileTabs.length;
        var mobileTabColumnClass = 'col-xs-' + mobileTabColumns;

        if($validMobileTabs.length == 1) {
            this.$mobileTabsContainer.addClass('d-none');
        }

        if ($validTabs.length > 4) {
            this.$tabs.addClass('vertical-layout');
        } else {
            this.$tabs.removeClass('vertical-layout');
        }

        for(var i = 0; i < $validTabs.length; i++) {
            var $tab = $validTabs[i];
            var $mobileTab = $validMobileTabs[i];
            this.setUpTab($tab, $mobileTab, tabColumnClass, i);
        }

        var $owlCarousel = this.$element.find('.int-carousel');

        // For mobile breakpoint
        if($validMobileTabs.length <= 3) {
            $owlCarousel.css('width',$('.PlanInteractiveTool').outerWidth())
                .removeClass('owl-carousel owl-theme')
                .children().first().css('border-left', 'none');

            this.$mobileTabs.addClass(mobileTabColumnClass);
            this.$mobileTabsContainer.css('width', 'fit-content');
        }
        else {
            // Setting up left/right arrow for mobile tab carousel
            $('.PlanInteractiveTool__slider-nav__prev, .PlanInteractiveTool__slider-nav__next').removeClass('d-none');
            this.$mobileTabsContainer.find('.int-carousel').css('width', '80%');

            $owlCarousel.addClass('mx-3');

            $owlCarousel.owlCarousel({
                loop: true,
                dots: false,
                autoHeight: true,
                nav: false,
                items: 3,
                center: false,
                startPosition: 0
            });
            
            this.$element.find('.PlanInteractiveTool__slider-nav__next').on('click', function (event) {
                event.stopPropagation();
                $owlCarousel.trigger('next.owl.carousel');
            });

            this.$element.find('.PlanInteractiveTool__slider-nav__prev').on('click', function (event) {
                event.stopPropagation();
                $owlCarousel.trigger('prev.owl.carousel');
            });

            // Remove all invalid tabs b/c owl carousel creates placeholder spots for them 
            $('div.PlanInteractiveTool__mobile-tab.invalid').parent().remove();
        }
    }

    this.setUpTab = function($tabContainer, $mobileTab, tabColumnClass,iteration) {
        $tabContainer.removeClass('d-none');
        $tabContainer.addClass(tabColumnClass);
        $mobileTab.removeClass('invalid');

        if(iteration == 0) {
            var $tab = $tabContainer.find('.PlanInteractiveTool__tab');
            window.webappIFP.showModule($tab.data('module-id'));
            $tab.addClass('selected');
            var tabIndex = $mobileTab.data('tab-index');
            $(this.$mobileHeaders[tabIndex]).removeClass('d-none');
            $mobileTab.addClass('selected');
        }
        $mobileTab.removeClass('d-none');
    }

}
 
module.exports = component(PlanInteractiveTool);
